@if (true === isSmall) {
<div
    class="asset__icon"
    [ngClass]="{'asset__icon--selected': selected === true}"
    (click)="imageClickEmitChange($event)"
>
    <i class="fas fa-image"></i>
</div>
}
<div [hidden]="true === isSmall" class="image-container">
    <ng-content></ng-content>
</div>
